import { setPreStyleGuideTheme } from "@insite/client-framework/ThemeConfiguration";
import { typography } from "@tggstore/Utilities/styleguide";
import { colorPalette as colors } from "@tggstore/Utilities/variables";

const setPreStyles = () => {
    // Add some post styleguide customizations. These cannot be overridden by the style guid.
    setPreStyleGuideTheme({
        colors,
        typography,
    });
};

export default setPreStyles;
